module.exports = __webpack_public_path__ + "img/bg-sanitation.5cbae73b.jpeg";